<template>
    <header :class="classes">
        <a href="/" class="c-header__logo">
            <logo/>
        </a>
        
        <a href="https://advanced-hindsight.com/" class="c-header__logo--cah">
            <img src="~assets/logo-solid.png">
        </a>
    </header>
</template>

<script>
    import Logo from "assets/logo.svg";

    export default {
        components: {
            logo: Logo
        },

        props: {
            compact: {
                type: Boolean,
                required: false,
                default: false
            },

            result: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            classes() {
                return {
                    "c-header": true,
                    "c-header--compact": this.compact,
                    "c-header--result": this.result
                };
            }
        }
    };
</script>

<style lang="scss">
    .c-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 2.937rem;
        padding-top: 1.875rem;

        &__logo {
            line-height: 3.75rem;

            &--cah {
                padding-top: 0.37rem;
                padding-right: 0.37rem;

                img {
                    display: block;
                    width: 8rem;
                    height: auto;
                }
            }
        }

        &--compact {
            padding-top: 1.437rem;
            padding-bottom: 0.937rem;
        }
    }
</style>
